export const styles: any = {
    CardInputContainer: {
        padding: 1,
        display: "flex",
        alignItems: "center",
        fontFamily: "primary",
        background: "white",
        borderWidth: "{{lineThickness.1}}",
        borderStyle: "solid",
        borderColor: "{{colors.grey.border}}",
        height: "{{space.5}}",
        borderRadius: 1,
        fontSize: "{{fontSizes.3}}",
        ":focus": {
            outline: "none",
            border: "{{focus.border}}",
        },
        "> div": {
            width: "100%",
        },
    },
    DisableStyles: {
        pointerEvents: "none",
        opacity: 0.6,
        cursor: "disabled",
    },
    UpdateButtonStyles: {
        width: "120px",
    },
    CancelButtonStyles: {
        marginLeft: "auto !important",
    },
    UpdateCardButtonStyles: {
        width: "fit-content",
        marginLeft: "auto !important",
    },
};
